import { combineReducers } from "redux";
import {
  GET_USER_INFO,
  GET_USER_INFO_FAILED,
  GET_USER_INFO_SUCCESS,
  SIGNIN_MASTER,
  SIGNIN_MASTER_FAILED,
  SIGNIN_MASTER_SUCCESS,
} from "store/actions/auth";

const initialState = {
  isLoading: false,
  data: {},
};

/**
 * auth reducer
 * @param {object} state
 * @param {object} action
 * @returns
 */
function login(state = initialState, action) {
  switch (action.type) {
    case SIGNIN_MASTER:
      return {
        ...state,
        isLoading: true,
      };
    case SIGNIN_MASTER_SUCCESS:
      return {
        ...state,
        ...action.payload,
        isLoading: false,
      };

    case SIGNIN_MASTER_FAILED:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
}

function userInfo(state = initialState, action) {
  switch (action.type) {
    case GET_USER_INFO:
      return {
        ...state,
        isLoading: true,
      };
    case GET_USER_INFO_SUCCESS:
      const { data = {} } = action.payload;
      return {
        ...state,
        ...data,
        isLoading: false,
      };

    case GET_USER_INFO_FAILED:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
}

export default combineReducers({
  login,
  userInfo,
});
